<template>
  <v-app-bar
    app
    color="white"
    class="header-nav"
  >
    <v-toolbar-items
      v-if="isLogin"
      class="d-flex d-sm-none"
      >
      <v-btn
        icon
        exact-active-class="nav-link-active"
        :to="{name: 'menu'}"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-toolbar-items>

    <v-toolbar-title
      v-if="isLogin"
      class="d-none d-sm-flex pl-0"
    >
      <router-link :to="{name: 'menu'}">
        <v-img
          :src="require('/src/assets/images/logo.svg')"
          contain
          :aspect-ratio="3/1"
          width="150px"
          height="50px"
          position="left"
        ></v-img>
      </router-link>
    </v-toolbar-title>
    <template
      v-if="isLogin"
    >
      <!-- ログイン時 -->
      <template v-for="nav in navList">
        <!-- メニューの種別リストでループ -->
        <template
          v-if="showNav(nav)"
        >
          <!-- propsで対象メニューを表示する様に指定されている場合 -->
          <v-toolbar-items
            v-for="(navItem, navIdx) in navItems(nav)" :key="navIdx"
          >
            <!-- 対象メニューの画面へのリンクを作成 -->
            <v-btn
              icon
              exact-active-class="nav-link-active"
              class="d-flex d-md-none"
              :to="navItem.to"
            >
              <v-icon>{{ navItem.icon }}</v-icon>
            </v-btn>
            <v-btn
              text
              exact-active-class="nav-link-active"
              class="d-none d-md-flex text--darken-2"
              :to="navItem.to"
            >
              <v-icon>{{ navItem.icon }}</v-icon>
              {{ navItem.text }}
            </v-btn>
          </v-toolbar-items>
        </template>
      </template>
    </template>
    <v-spacer></v-spacer>
    <div
      v-if="isLogin"
      class="lack--text text-left"
    >
      <div class="font-weight-bold">{{ companyName }}（{{ companyCode }}）</div>
      <div>{{ username }}（{{ userCode }}）</div>
    </div>
    <v-divider
        vertical
        inset
        class="ml-5"
    ></v-divider>
    <v-toolbar-items
      v-if="isLogin && showNavStore"
    >
      <v-btn
        icon
        exact-active-class="nav-link-active"
        :to="navStoreTo"
      >
        <v-icon>mdi-storefront-outline</v-icon>
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-items
      v-if="isLogin"
    >
      <v-menu offset-y>
        <template v-slot:activator="{on}">
          <v-btn
            v-if="isLogin"
            v-on="on"
            class=""
            icon
          >
            <v-icon>mdi-exit-to-app</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            @click.stop="logout"
            link
          >
            <v-list-item-content>
              <v-list-item-title>
                ログアウト
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    showNavComparison: {
      type: Boolean
    },
    showNavDemand: {
      type: Boolean
    },
    showNavStore: {
      type: Boolean
    }
  },
  data () {
    return {
      navList: [
        'Comparison',
        'Demand'
      ],
      navItemsComparison: [
        {icon: 'mdi-text-search', text: '比較基準', to: {name: 'comparison.base'}},
        {icon: 'mdi-chart-timeline-variant-shimmer', text: 'レポート',  to: {name: 'comparison.summary'}},
      ],
      navItemsDemand: [
        {icon: 'mdi-account-search-outline', text: '来客予測', to: {name: 'demand.visitor'}},
      ],
    }
  },
  computed: {
    ...mapGetters ({
      isLogin: 'auth/check',
      username: 'auth/name',
      userCode: 'auth/user_code',
      companyName: 'auth/company_name',
      companyCode: 'auth/company_code',
    }),
    navStoreTo: function () {
      let to = {}
      if (this.showNavComparison) {
        to = {name: 'comparison.store'}
      } else {
        to = {name: 'demand.store'}
      }
      return to
    },
    showNav: function () {
      return function (nav) {
        return this['showNav' + nav]
      }
    },
    navItems: function () {
      return function (nav) {
        return this['navItems' + nav]
      }
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/logout')
      await this.$router.push('/login')
    },
  }
}
</script>
<style lang="scss">
  .nav-link-active:hover::before,
  .nav-link-active::before {
    opacity: 0!important;
  }
  .nav-link-active:hover, .nav-link-active {
    color: #0074B7!important;
  }
</style>